import { makeStyles } from "@material-ui/core"

export default makeStyles((theme) => ({
	root: {},
	reviewSection: {
		marginBottom: 7,
		paddingLeft: 5,
	},
	reviewName: {
		color: theme.palette.text.primary,
		fontWeight: 500,
		marginRight: 30,
		minWidth: 100,
	},
	reviewDetails: {
		color: theme.palette.primary.dark,
		cursor: "pointer",
	},
	metaDataRoot: {
		display: "flex",
		maxWidth: 390,
		minWidth: 390,
		maxHeight: 500,
		padding: "12px 0",
		margin: 0,
	},
	paddingLR12: {
		padding: "0 12px",
	},
	reviewBased: {
		color: theme.palette.grey.D100,
		fontWeight: 600,
	},
	padding8: {
		paddingTop: 8,
		paddingBottom: 8,
	},
	borderTop: {
		borderTop: `1px solid ${theme.typography.button.disabledColor}`,
	},
	searchName: {
		color: theme.palette.text.primary,
		fontWeight: 400,
	},
	keyword: {
		color: theme.palette.text.primary,
		fontWeight: 400,
	},
	conceptName: {
		color: theme.palette.primary.main,
		fontWeight: 400,
	},
	heading: {
		color: theme.palette.grey.D100,
		fontWeight: 400,
		backgroundColor: theme.palette.grey.D1400,
	},
	flex: {
		display: "flex",
	},
	alignItemCentrer: {
		alignItems: "center",
	},
	filtertype: {
		color: theme.palette.grey.D100,
		marginRight: 5,
		whiteSpace: "nowrap",
	},
	filterData: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		display: "-webkit-box",
		WebkitLineClamp: 3,
		WebkitBoxOrient: "vertical",
	},
	dueDateText: {
		color: theme.palette.grey.D100,
		fontWeight: 400,
		marginRight: 5,
	},
	dueDate: {
		color: theme.palette.error.main,
		fontWeight: 400,
	},
	avatar: {
		marginRight: 8,
	},
	ownerName: {
		color: theme.palette.grey.D100,
		fontWeight: 500,
	},
	createdBy: {
		color: theme.palette.grey.D100,
		marginRight: 5,
	},
}))
